import React from 'react';
import { MenuItem } from '@mui/material';
import { Link } from '../../utils/AvRouter';

interface Props {
  hasPermissions?: boolean;
  onClick: () => void;
  pathName: string;
  title: string;
}

const AvMenuItem: React.FC<Props> = ({ pathName, onClick, hasPermissions, title }) =>
  hasPermissions && (
    <MenuItem onClick={onClick} component={Link as any} to={pathName} params={prev => prev}>
      {title}
    </MenuItem>
  );
export default AvMenuItem;
